/**
 * The /faq page, one renderer for the server and the client (2026-10-04).
 *
 * The server sent the heading and the questions without the masthead, the
 * filters or the support block; the client drew all of them, so the page
 * changed shape when the script arrived. Both printed their layout as inline
 * styles. Both now print this markup, styled in faq.css.
 */
function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
export const FAQ_GROUPS = [
    { cat: 'setup', roman: 'i.', chapterKey: 'chapterOne', titleKey: 'groupSetup', filterKey: 'filterSetup' },
    { cat: 'pricing', roman: 'ii.', chapterKey: 'chapterTwo', titleKey: 'groupPricing', filterKey: 'filterPricing' },
    { cat: 'account', roman: 'iii.', chapterKey: 'chapterThree', titleKey: 'groupAccount', filterKey: 'filterAccount' },
    { cat: 'crypto', roman: 'iv.', chapterKey: 'chapterFour', titleKey: 'groupCrypto', filterKey: 'filterCrypto' },
    { cat: 'support', roman: 'v.', chapterKey: 'chapterFive', titleKey: 'groupSupport', filterKey: 'filterSupport' },
];
/** Everything inside `<div class="faq-route">`. */
export function faqPageHtml({ labels, qas }) {
    const l = (k) => esc(labels[k] ?? '');
    const groups = FAQ_GROUPS.map((g) => {
        const items = qas.filter((q) => q.cat === g.cat);
        if (!items.length)
            return '';
        return `<div class="faq-group" data-group="${g.cat}">
  <div class="faq-group__header">
    <span class="section__number faq-group__number">${g.roman}</span>
    <div>
      <div class="section__kicker faq-group__kicker">${l(g.chapterKey)}</div>
      <h2 class="faq-group__title">${l(g.titleKey)}</h2>
    </div>
  </div>
  <div class="faq-list">
    ${items.map((q) => `<details class="faq-item"><summary class="faq-question">${esc(q.q)}</summary><div class="faq-answer">${esc(q.a)}</div></details>`).join('')}
  </div>
</div>`;
    }).join('');
    return `
<section class="hero listing-hero">
  <div class="container">
    <div class="hero__masthead">
      <div class="hero__volume">${l('volume')}</div>
      <div class="hero__edition">${l('edition')}</div>
      <div class="hero__date">MMXXVI</div>
    </div>
    <div class="listing-hero__body">
      <div class="section__kicker">${l('kicker')}</div>
      <h1 class="listing-hero__title">${l('title')}</h1>
      <p class="listing-hero__lede">${l('lede')}</p>
    </div>
  </div>
</section>

<section class="faq-filters">
  <div class="container">
    <button class="faq-filter faq-filter--active" data-cat="all">${l('filterAll')}</button>
    ${FAQ_GROUPS.map((g) => `<button class="faq-filter" data-cat="${g.cat}">${l(g.filterKey)}</button>`).join('\n    ')}
  </div>
</section>

<section class="section faq-groups">
  <div class="container">
    ${groups}
  </div>
</section>

<section class="section faq-support">
  <div class="container">
    <div class="section__kicker">${l('stillCurious')}</div>
    <h2 class="faq-support__title">${l('askDirectly')}</h2>
    <p class="faq-support__line">${l('supportLine')}</p>
    <a class="btn btn--primary btn--lg" href="https://t.me/roamzy_support_bot" rel="noopener">${l('supportCta')}</a>
  </div>
</section>
`;
}
